import { useState } from 'react';
import MovimientosList from './List.jsx';
import MovimientoForm from './Form.jsx';
import MovimientoDetail from './Detail.jsx';

export default function MovimientosPage() {
  const [view, setView] = useState('list');
  const [mode, setMode] = useState('ingreso');
  const [selected, setSelected] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = () => setRefreshKey((value) => value + 1);

  const handleBack = () => {
    setView('list');
    setSelected(null);
    refresh();
  };

  const handleSaved = () => {
    setView('list');
    setSelected(null);
    refresh();
  };

  if (view === 'form') {
    return <MovimientoForm mode={mode} onCancel={handleBack} onSaved={handleSaved} />;
  }

  if (view === 'detail' && selected) {
    return (
      <MovimientoDetail
        movimientoId={selected.id}
        tipo={selected.tipo}
        onBack={handleBack}
      />
    );
  }

  return (
    <MovimientosList
      refreshKey={refreshKey}
      onCreateIngreso={() => {
        setMode('ingreso');
        setSelected(null);
        setView('form');
      }}
      onCreateEgreso={() => {
        setMode('egreso');
        setSelected(null);
        setView('form');
      }}
      onTransferir={() => {
        setMode('transferencia');
        setSelected(null);
        setView('form');
      }}
      onSelectIngreso={(id) => {
        setSelected({ id, tipo: 'ingreso' });
        setView('detail');
      }}
      onSelectEgreso={(id) => {
        setSelected({ id, tipo: 'egreso' });
        setView('detail');
      }}
    />
  );
}
